import axios from "axios"
import { baseUrlApi } from "./Api.js"
import Csrf from "./Csrf.js"

export default {

  getCarsType() {
    //Csrf.getCsrfToken();
    const url = `${baseUrlApi}/get-cars-types`;
    return axios.get(url);
  },

  getCarsBrands() {
    //Csrf.getCsrfToken();
    const url = `${baseUrlApi}/get-cars-brands`;
    return axios.get(url);
  },

  postCarsModels(carBrandId) {
    //Csrf.getCsrfToken();
    const url = `${baseUrlApi}/post-cars-models-id`;
    return axios.post(url, carBrandId);
  },
};

